import React from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  Row
} from "react-bootstrap";

import ShowNotification from "../../../Notification/LoadableShowNotification";

function ForgotPassword(props) {
  const {
    showForgotForm,
    forgotSuccess,
    forgotError,
    closeForgotError,
    forgotPassword,
    forgotFormSubmitted,
    forgotFormErrors,
    handleForgotInputChange,
    forgotFormData,
    showForm
  } = props;

  return (
    showForgotForm && (
      <div className="Login for_password">
        {!forgotSuccess && (
          <section>
            {/* {forgotError && (
              <ShowNotification
                closeError={closeForgotError}
                errorHeading={`Email address not found.`}
                errorDesc={`We were unable to find an account linked to this email.`}
              />
            )} */}
            <section className="login-form">
              {forgotError && (
                <div className="error--box">
                  <h4>Email address not found</h4>
                  <p>We were unable to find an account linked to this email.</p>
                </div>
              )}
              <Row>
                <form onSubmit={forgotPassword}>
                  <FormGroup
                    controlId="forgot_email"
                    validationState={
                      forgotFormSubmitted
                        ? forgotFormErrors.email
                          ? "error"
                          : "success"
                        : null
                    }
                  >
                    <ControlLabel className="reset-password">
                      To reset your password, enter the email address you use to
                      sign in
                    </ControlLabel>
                    <FormControl
                      type="text"
                      name="email"
                      // placeholder="Please enter your email address"
                      onChange={handleForgotInputChange}
                    />
                    {forgotFormErrors.email && (
                      <HelpBlock>{forgotFormErrors.email}</HelpBlock>
                    )}

                    <div className="back-to--login">
                      <section id="TermsAndConditions">
                        <span>
                          Reset Password?{" "}
                          <a href="#/">
                            <span
                              onClick={env => showForm("login")}
                              className="signLink"
                            >
                              Back to Login
                            </span>
                          </a>
                        </span>

                        <Button
                          type="submit"
                          bsStyle="primary"
                          className="btn-style get-instruction-btn"
                        >
                          Get Instructions
                        </Button>
                      </section>
                    </div>
                  </FormGroup>
                </form>
              </Row>
            </section>
          </section>
        )}
        {forgotSuccess && (
          <section className="pass_reset">
            <div>
              <p>
                {`If an account is found linked to email ${(forgotFormData &&
                  forgotFormData.email) ||
                  ""}, you would receive an email with password reset instructions shortly. Check your inbox and follow the instructions to reset your password.`}
              </p>
              <button
                type="button"
                className="ant-btn"
                onClick={env => showForm("login")}
              >
                <i
                  aria-label="icon: login"
                  className="anticon anticon-login"
                ></i>
                <span className="icon_lock">Back to Login</span>
              </button>
            </div>
          </section>
        )}
      </div>
    )
  );
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/Login/SubComponents/ForgotPassword/ForgotPassword.js